import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalCloseButton,
} from '@chakra-ui/react'
import ButtonCTA from '../button'
import { useLanguageContext } from './../../../context/locale.context'

const ConfirmationModal = ({
	isOpen,
	onClose,
	headerText,
	onClickYes,
	onClickYesProps,
}) => {
	const {
		state: { locale },
	} = useLanguageContext()

	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered size='md'>
			<ModalOverlay />
			<ModalContent
				pl='4.6rem'
				pr='4.6rem'
				pt='5.125rem'
				pb='5.125rem'
				borderRadius='20px'
			>
				<ModalHeader textAlign='left' fontWeight='400' fontSize='1.5rem'>
					{headerText}
				</ModalHeader>
				<ModalCloseButton m={2} />

				<ModalFooter
					justifyContent='center'
					gap='0.8125rem'
					fontWeight='900'
					fontSize='0.875rem'
					pb={0}
				>
					<ButtonCTA
						bg='white'
						border='2px solid #009B76'
						borderRadius='18px'
						h='2.25rem'
						onClick={onClose}
						color='brand.700'
						_hover={{
							background: 'white',
						}}
					>
						{locale['No']}
					</ButtonCTA>
					{!!onClickYes && (
						<ButtonCTA
							bg='linear-gradient(225deg, #009B76 0%, #0F7A5E 100%, #24A490 100%)'
							borderRadius='18px'
							color='white'
							h='2.25rem'
							onClick={() => onClickYes(onClickYesProps)}
							_hover={{
								background:
									'linear-gradient(225deg, #009B76 0%, #0F7A5E 100%, #24A490 100%)',
							}}
						>
							{locale['Yes']}
						</ButtonCTA>
					)}
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export { ConfirmationModal }
